import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "cssBoxShadow"];
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "PPUIGridItem__StyledDiv"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
const gridItemStylePropKeys = {
  gridArea: true,
  placeSelf: true,
  gridRow: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridColumn: true,
  gridColumnStart: true,
  gridColumnEnd: true
};
function filterGridItemProps(props) {
  const gridItemProps = {};
  const rest = {};
  Object.keys(props).forEach(key => {
    if (key in gridItemStylePropKeys) {
      gridItemProps[key] = props[key];
    } else {
      rest[key] = props[key];
    }
  });

  // Trellis filterProps only supports tokenized props, which does NOT include grid style props
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(rest);
  return {
    gridItemProps,
    domProps,
    tokenProps,
    callbackProps
  };
}
export const PPUIGridItem = _ref => {
  let {
      children,
      cssBoxShadow
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    gridItemProps,
    domProps,
    tokenProps,
    callbackProps
  } = filterGridItemProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const boxShadow = cssBoxShadow !== null && cssBoxShadow !== void 0 ? cssBoxShadow : cssStyles.boxShadow;
  return /*#__PURE__*/_jsx(StyledDiv, Object.assign({}, domProps, callbackProps, {
    $cssStyles: Object.assign({}, cssStyles, gridItemProps, {
      boxShadow
    }),
    children: children
  }));
};